import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import Mysales from '../components/Mysales'
import NewOrder from '../components/LexusNewOrder'
import Finance from '../components/Finance'
import YaoXing from '../components/YaoXing'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/sales',
            name: 'Mysales',
            component: Mysales
        },
        {
            path: '/charge',
            name: 'NewOrder',
            component: NewOrder
        },
        {
            path: '/yaoxing',
            name: 'YaoXing',
            component: YaoXing
        },
        {
            path: '/finance',
            name: 'Finance',
            component: Finance
        },
    ]
})
